export const truncateToTwoDecimals = (value: number) => {
  return Math.floor(value * 100) / 100;
};
